import React from 'react';
import './campaign-details-header.scss';
import { DateRange } from '@material-ui/pickers';
import { default as t } from '../../../utils/i18n';
const CampaignDetailsHeader = ({campaignDetails}) => {
  if(campaignDetails && campaignDetails.stop_time) {
    campaignDetails['dateRange'] = `${campaignDetails.start_time} to ${campaignDetails.stop_time}`;
  } else {
    campaignDetails['dateRange'] = `${campaignDetails.start_time} onwards`
  }
    const campaign = campaignDetails;
    return (
        <div className='common-header'>
          <div className='campaign-details'>
          {campaign && Object.keys(campaign).length > 0 &&
            <div className="row">
              <div className='column-1'>
                {campaign?.name && <h3 className='campaign-name' title={campaign.name}>{campaign.name}</h3>}
              </div>
              <div className='column-2 opace'>
              {t('campaign.details.id')}
                <div className='campaign-values' title={campaign?.id}>{campaign?.id}</div>
              </div>
              <div className='column-2' style={{width:'16%'}}>
              {t('campaign.details.date.range')}
              <div className='campaign-values' title={campaign?.dateRange}>{campaign.start_time}{campaign.stop_time ? <span> {t('campaign.details.to')} {campaign.stop_time}</span>: <span>{t('campaign.details.onwards')}</span> }</div>
              </div>
              <div className='column-2' style={{width:'12%'}}>
               {t('campaign.details.budget')} {campaign?.account_currency && <span>({campaign?.account_currency})</span>}
               <div className='campaign-values' title={campaign?.budget}>{campaign?.budget}</div>
              </div>
              <div className='column-2' style={{border: 'none', width:'19%'}}>
                {t('campaign.details.Objective')}
                <div className='campaign-values objective-overflow' title={campaign.objective}>{campaign.objective}</div>
              </div>

            </div>
}
          </div>
        </div>
    );
}

export default CampaignDetailsHeader;     